import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  ...props
}: TextareaProps) {
  return <div className="w-full" data-id="element-172">
      {label && <label className="block text-sm font-medium text-text-secondary mb-1.5" data-id="element-173">
          {label}
        </label>}
      <textarea className={`
          block w-full rounded-lg border border-slate-700 bg-slate-800/50 
          text-text-primary placeholder-text-muted
          focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none
          disabled:opacity-50 disabled:cursor-not-allowed
          transition-colors duration-200
          py-2.5 px-3 min-h-[100px]
          ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
          ${className}
        `} {...props} data-id="element-174" />
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-175">{error}</p>}
    </div>;
}